import React from "react";
import { useQuickSightRDS  } from "@/hooks/useRDSReports";

const QuickSightAwsRDSDashboard = () => {
  const { embedUrl } = useQuickSightRDS ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsRDSDashboard;
